import axios from 'axios';

export const isNetworkError = (error: unknown) =>
	axios.isAxiosError(error) &&
	!error.response &&
	['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error.code || '');

// Keep existing query data while a transport failure is retried. React Query
// pauses these retries offline and resumes them when the connection returns.
export const retryNetworkErrors = (_failureCount: number, error: unknown) => isNetworkError(error);
